module.exports = __webpack_public_path__ + "img/nba-2k20.9199baec.png";